export function btOnlyNumbers(str, allowDots = false, fixed = -1) {
  var num = +str.replace(allowDots ? /(?!-)[^0-9.]/g : /\D/g, '');

  if (fixed > -1) {
    var tt = num + '';
    if (tt.indexOf('.') != -1) {
      num = num.toFixed(fixed);
    }
  }

  return num;
}

export function btRemoveNumbers(str) {
  return str.replace(/[0-9]/g, '');
}

export function btFormatNumber(num, fixed = -1) {
  if (fixed > -1) {
    var tt = num + '';
    if (tt.indexOf('.') != -1) {
      num = +num;
      num = num.toFixed(fixed);
      tt = num + '';

      if (tt.indexOf('.00') >= 0) {
        num = +num;
      }
    }
  }

  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}

export const checkOrgNo = orgNo => {
  return /^\d{6}-\d{4}$/.test(orgNo);
};

export const isValidOrganizationNumber = num => {
  const check1 = /^[0-9]*$/.test(num.slice(0, 6));
  const hasDash = num.slice(6, 7) == '-';
  const check2 = num.slice(7) != '' ? /^[0-9]*$/.test(num.slice(7)) : true;

  return num.length < 7 ? check1 : check1 && hasDash && check2;
};

export const isValidABOrganizationNumber = orgnr => {
  const organizationNumber = orgnr.replace('-', '');
  const abRegex = /^55[6-9]\d{7}$/;
  if (!abRegex.test(organizationNumber)) return false;

  const digits = organizationNumber.split('').map(Number);
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    let digit = digits[i];
    if (i % 2 === 0) digit *= 2;
    if (digit > 9) digit -= 9;
    sum += digit;
  }

  const controlDigit = digits[9];
  return (sum + controlDigit) % 10 === 0;
}
